import React, { useState } from 'react'
import styled from 'styled-components'
import { useTranslate } from '@tolgee/react';
import { ReactComponent as CloseIcon } from "../../Assets/iconsv2/generic/closeBtn.svg";
import "../../Assets/styles/customPhoneSelect.css";
import "react-phone-number-input/style.css";

import PrimaryButton from '../GenericComponents/PrimaryButton';
import { useAuthService } from '../../Context/AuthContext';
import { useNotify } from '../../Helpers/Notifications';
import { PasswordInput } from '../Auth Components/shared/AuthUI';
import { PASSWORD_REQUIREMENTS, isStrongPassword } from '../../Helpers/passwordValidation';
import { getAuthErrorMessage } from '../../API/emailAuthErrors';

import { useGenericComponentsStateService } from '../../Context/GenericComponentsStateContext';
import OtpInput from "react-otp-input";
import LocalStorage from '../../Helpers/LocalStorage';
import validator from "validator";


const LinkEmailModal = ({ closeLinkEmailModal }) => {
    const [phase, setPhase] = useState(1);
    const [email, setEmail] = useState("");

    const [wrongCode, setWrongCode] = useState(false);
    const [otp, setOtp] = useState("");

    const [password, setPassword] = useState("");
    const [confirm, setConfirm] = useState("");
    const [passwordError, setPasswordError] = useState(null);

    const { notifyError, notifySuccess } = useNotify()
    const { canLink, authenticateEmail, linkEmail, handleLoginUser, setLinkedEmailPassword } = useAuthService()
    const { setLoading } = useGenericComponentsStateService()


    const ssoAuth = LocalStorage.getSSOFlag()

    const { t } = useTranslate();

    const handleTryLinkemail = (email) => {
        const sendData = {}
        sendData.email = email
        canLink(
            sendData,
            (response) => {
                let canLink = response.data.can_link
                if (canLink) {
                    handleSendCodeToEmail(email)
                } else {
                    notifyError(t('settings.link_email_error'))
                }
            },
            (error) => {
                console.log(error)
                notifyError(t('general.something_wrong'))
            }

        )

    }

    const handleSendCodeToEmail = (email) => {
        setLoading(true)
        authenticateEmail(email,
            (response) => {
                console.log(response, "RESPONSE");
                setLoading(false)
                setPhase(2)
            }, (error) => {
                console.log(error)
                notifyError(t('general.something_wrong'))
                setLoading(false)
            }
        )
    }

    const handleLinkEmail = (otp, email) => {
        setWrongCode(false);
        setLoading(true);
        linkEmail(otp, email,
            (response) => {
                const user = response.data.user;
                handleLoginUser(user);
                setLoading(false)
                setPhase(3)
            }, (error) => {
                setWrongCode(true);
                notifyError(getAuthErrorMessage(error?.response?.data?.error, t))
                setLoading(false)
            }
        )
    }

    const handleSetPassword = () => {
        if (!isStrongPassword(password) || password !== confirm) return;
        setPasswordError(null);
        setLoading(true);
        setLinkedEmailPassword(
            password,
            (response) => {
                handleLoginUser(response.data.user);
                setLoading(false);
                closeLinkEmailModal();
            },
            (error) => {
                setPasswordError(getAuthErrorMessage(error?.response?.data?.error, t));
                setLoading(false);
            }
        );
    }


    const phase1 =
        <ContentContainer>
            <InfoText>{t('settings.link_email_info_text')}</InfoText>
            <EmailInputWrapper>
                <CustomInput
                    value={email}
                    onChange={(e) => setEmail(e.currentTarget.value)}
                    name="email"
                    maxLength={100}
                    placeholder={t('settings.enter_email')}
                >
                </CustomInput>
            </EmailInputWrapper>
            <PrimaryButton
                disabled={!validator.isEmail(email)}
                style={{ padding: "16px" }}
                text={t('settings.send_verification_email')}
                onClick={() => handleTryLinkemail(email)}
            />
        </ContentContainer>


    const phase2 =
        <ContentContainer>
            <InfoText>{t('settings.link_email_info_text_code')}</InfoText>
            <OtpInputWrapper>
                <OtpInput
                    containerStyle={{
                        display: "flex",
                        justifyContent: "space-around",
                        width: "100%",
                        gap: "5px"
                    }}
                    shouldAutoFocus
                    inputStyle={wrongCode ? { borderColor: "red" } : {}}
                    value={otp}
                    onChange={setOtp}
                    numInputs={6}
                    renderSeparator={<span> </span>}
                    renderInput={(props) => <input id="opt-input" {...props} />}
                />



            </OtpInputWrapper>
            {wrongCode && <WrongCodeStatus>
                <p>{t('login.wrong_validation_code')}</p></WrongCodeStatus>}
            <PrimaryButton
                disabled={otp.length !== 6}
                style={{ padding: "16px" }}
                text={t('settings.validate_and_link_email')}
                onClick={() => handleLinkEmail(otp, email)}
            />
        </ContentContainer>

    const allRequirementsMet = isStrongPassword(password);
    const passwordsMatch = password === confirm;
    const canSetPassword = allRequirementsMet && passwordsMatch && confirm.length > 0;

    const phase3 =
        <ContentContainer>
            <InfoText>{t('settings.set_password_info_text')}</InfoText>
            <PasswordInput
                value={password}
                onChange={(e) => { setPassword(e.target.value); setPasswordError(null); }}
                placeholder={t('authentication.set_password.new_placeholder')}
                autoComplete="new-password"
            />
            <PasswordInput
                value={confirm}
                onChange={(e) => { setConfirm(e.target.value); setPasswordError(null); }}
                placeholder={t('authentication.set_password.confirm_placeholder')}
                autoComplete="new-password"
                onKeyDown={(e) => { if (e.key === 'Enter') handleSetPassword(); }}
            />
            {password.length > 0 && (
                <RequirementsList>
                    {PASSWORD_REQUIREMENTS.map((r) => (
                        <Requirement key={r.key} met={r.test(password)}>
                            <ReqDot met={r.test(password)} />
                            {t(r.key)}
                        </Requirement>
                    ))}
                    {confirm.length > 0 && !passwordsMatch && (
                        <Requirement met={false}>
                            <ReqDot met={false} />
                            {t('authentication.set_password.passwords_must_match')}
                        </Requirement>
                    )}
                </RequirementsList>
            )}
            {passwordError && <WrongCodeStatus><p>{passwordError}</p></WrongCodeStatus>}
            <PrimaryButton
                disabled={!canSetPassword}
                style={{ padding: "16px" }}
                text={t('settings.set_password_button')}
                onClick={handleSetPassword}
            />
        </ContentContainer>

    var content = phase1;

    switch (phase) {
        case 1:
            content = phase1;
            break;
        case 2:
            content = phase2;
            break;
        case 3:
            content = phase3;
            break;
        default:
            break;
    }



    return (
        <FullScreenContainer>
            <Container>
                <Header>
                    <Title>
                        {t('settings.link_email')}
                    </Title>
                    <CloseBtn>
                        <CloseIcon onClick={closeLinkEmailModal} />
                    </CloseBtn>
                </Header>
                {content}
            </Container>
        </FullScreenContainer>
    )
}

export default LinkEmailModal


const FullScreenContainer = styled.div`
display:flex;
align-items:center;
justify-content:center;
position:fixed;
width:100%;
height:100%;
background:rgba(0,0,0,0.3);
left:0;
top:0;
z-index:2;
`
const Container = styled.div`
display:flex;
flex-direction:column;
padding:25px;
width:100%;
max-width:500px;
background:${({ theme }) => theme.menu.groupContentBackground};
gap:20px;
border-radius:10px;
overflow:hidden;
`

const Header = styled.div`
display:flex;
align-items:center;
justify-content:space-between;
gap:10px;
`
const CloseBtn = styled.button`
display:flex;
align-items:center;
background:none;
border:none;
cursor:pointer;
color:${({ theme }) => theme.menu.selectedOpionBackground};
stroke:${({ theme }) => theme.sidebar.borderColor};
`

const Title = styled.p`
font-weight: 700;
font-size: 20px;
line-height: 100%;
letter-spacing: 0.04px;
vertical-align: middle;
color:${({ theme }) => theme.menu.primaryTextColor};

`


const InfoText = styled.p`

    font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  vertical-align: middle;
  color: ${({ theme }) => theme.menu.secondaryTextColor};
span{
color: ${({ theme }) => theme.menu.selectedTextColor};
cursor:pointer;
}
`

const OtpInputWrapper = styled.div`
  display: flex;
  width: 100%;

  input {
    padding: 14px 16px;
    min-width: 50px;
    border-radius: 10px;
    border: 1px solid ${({ theme }) => theme.sidebar.borderColor};
    color:${({ theme }) => theme.menu.primaryTextColor};
    background:${({ theme }) => theme.menu.enterPhoneNumberBackground};
    width: 100%;
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    text-align: left;
    &:focus {
        outline: none;
      }
  }
  
`;
const WrongCodeStatus = styled.div`
p{
   color:${({ theme }) => theme.menu.deleteColor};
font-size: 14px;
font-weight: 500;
line-height: 17px;
letter-spacing: 0px;
text-align: left;

}
`

const ContentContainer = styled.div`
display:flex;
flex-direction:column;
gap:20px;
width:100%;
height:100%;
`

const CustomInput = styled.input`
  width: 100%;
  background: none;
  border: none;
 color: ${({ theme }) => theme.menu.primaryTextColor};
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: -0.41px;
  &:focus-visible {
    outline: none;
  }
`;
const EmailInputWrapper = styled.div`
 background: ${({ theme }) => theme.menu.enterPhoneNumberBackground};
   border-radius: 4px;
     display: flex;
  align-items: center;
  width: 100%;
  padding:16px;
`

const RequirementsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px 14px;
  border-radius: 10px;
  background: ${({ theme }) => theme.menu.enterPhoneNumberBackground};
`;

const Requirement = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: ${({ met, theme }) => met ? "#23c55e" : theme.menu.secondaryTextColor};
  transition: color 0.2s;
`;

const ReqDot = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: ${({ met }) => met ? "#23c55e" : "currentColor"};
  flex-shrink: 0;
  opacity: ${({ met }) => met ? 1 : 0.4};
`;